import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsToggleComponent } from "./ds-toggle.component";

@NgModule({
  declarations: [DsToggleComponent],
  imports: [CommonModule],
  exports: [DsToggleComponent],
})
export class DsToggleModule {}
